<template>
    <div
        class="summary__right"
        v-if="deliveryDetailsType !== VS_STOCK_TYPE_DELIVERY_METHOD.UNKNOWN"
    >
        <section class="detail stock-type">
            <h3 class="section__heading">Delivery</h3>
            <template v-if="order.event.is_guest_list">
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-ticket-2"></span>
                            <span><strong>{{ billingAddress.first_name }} {{ billingAddress.last_name }}</strong> will be added to the guest list once your order is confirmed.</span>
                        </div>
                    </li>
                </ul>
            </template>
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.TICKETMASTER_TRANSFER === deliveryDetailsType">
                <h4>Mobile Access</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Instructions on how to access your tickets will be emailed to <strong>{{ order.customer.email_address }}</strong> when your tickets are released</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-print-ticket"></span>
                            <span>Typically tickets are released quickly, but some venues withhold tickets until 48 hours prior to the event</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-mobile-qr"></span>
                            <span>Tickets must be displayed on your iOS or Android device to gain access to the event</span>
                        </div>
                    </li>
                </ul>
            </template> <!-- TMET basic ends -->
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.TICKETMASTER_TEXT_TRANSFER === deliveryDetailsType">
                <h4>Mobile Access</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Instructions on how to access your tickets will be sent by text message to <strong>{{billingAddress.phone_number}}</strong> when your tickets are released</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-print-ticket"></span>
                            <span>Typically tickets are released quickly, but some venues withhold tickets until 48 hours prior to the event</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-mobile-qr"></span>
                            <span>Tickets must be displayed on your iOS or Android device to gain access to the event</span>
                        </div>
                    </li>
                </ul>
            </template> <!-- TMET text ends -->
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.TICKETMASTER_INSTANT_TRANSFER === deliveryDetailsType">
                <h4>Instant Mobile Access</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Instructions on how to access your tickets will be emailed to <strong>{{ order.customer.email_address }}</strong> in the next few minutes</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-mobile-qr"></span>
                            <span>Tickets must be displayed on your iOS or Android device to gain access to the event</span>
                        </div>
                    </li>
                </ul>
            </template> <!-- TicketMaster instant ends -->
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.E_TICKETS_INSTANT === deliveryDetailsType">
                <h4>Instant Download</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Your tickets will be emailed to <strong>{{ order.customer.email_address }}</strong> in the next few minutes</span>
                        </div>
                    </li>
                </ul>
                <div v-if="order.current_status === ORDER_STATUS.SENT_TO_BUYER"
                    class="ticket-download"
                >
                    <template v-if="hasTicketEmailDownload">
                        <a class="ticket-download__action order__action"
                            target="_blank"
                            :href="order.ticket.fulfillment.links[0]"
                        >
                            Download
                        </a>
                    </template>
                    <template v-if="hasTicketPdfDownload">
                        <a class="ticket-download__action order__action"
                            target="_blank"
                            :href="order.ticket.fulfillment.pdf.url"
                        >
                            Download
                        </a>
                    </template>
                </div>
            </template>
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS_WALK_IN === deliveryDetailsType">
                <h4>Local Pickup</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Tickets will be available on the venue premises on the day of the event</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-print-ticket"></span>
                            <span>Location details and contact information will be sent to <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                </ul>
            </template> <!-- PAPERLESS_WALK_IN ends -->
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.E_TICKETS === deliveryDetailsType">
                <h4>E-mail Delivery</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Your tickets will be emailed to <strong>{{ order.customer.email_address }}</strong> when they are released</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-print-ticket"></span>
                            <span>Typically tickets are released quickly, but some venues withhold tickets until 48 hours prior to the event</span>
                        </div>
                    </li>
                </ul>
            </template> <!-- E-Tickets ends -->
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.FLASH === deliveryDetailsType">
                <h4>AXS Mobile ID (formerly Flash Seats®)</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-alert"></span>
                            <span>If you do not have a AXS Mobile ID (formerly Flash Seats&reg;) account, sign up on <a href="https://axs.com" target="_blank">axs.com</a> using email address <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-ticket-2"></span>
                            <span>Tickets will be transferred to your AXS Mobile ID account</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-mobile-qr"></span>
                            <span>Display tickets in the AXS Mobile ID App for entry</span>
                        </div>
                    </li>
                </ul>
            </template> <!-- Flash ends -->

            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.HARD_COURIERED_TO_CUSTOMER === deliveryDetailsType">
                <h4>Shipped via UPS</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-truck"></span>
                            <span>Tickets will be shipped to <ShippingAddress :shipping-address="shippingAddress" /></span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>A tracking number will be sent to <strong>{{ order.customer.email_address }}</strong> when the tickets have been shipped</span>
                        </div>
                    </li>
                </ul>
                <div v-if="hasTicketTrackingNumber" class="tracking-information">
                    <h3 class="tracking-information__header">Tracking Number</h3>
                    <div class="tracking-information__tracking_number"><span v-html="order.ticket.delivery_method"></span> #{{ order.ticket.fulfillment.tracking.number }} </div>
                    <a
                        class="order__action"
                        target="_blank"
                        :href="order.ticket.fulfillment.tracking.url">
                            Track My Order
                    </a>
                </div>
            </template> <!-- Hard couriered ends-->
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.HARD_PICKUP_NEAR_VENUE === deliveryDetailsType">
                <h4>Local Pickup</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-truck"></span>
                            <span>Pick up your tickets near the venue before your event. Location details and contact information will be sent to <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>A tracking number will be sent to <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-ticket-2"></span>
                            <span>At the venue, present your tickets for entry</span>
                        </div>
                    </li>
                </ul>
                <div v-if="hasTicketTrackingNumber" class="tracking-information">
                    <h3 class="tracking-information__header">Tracking Number</h3>
                    <div class="tracking-information__tracking_number"><span v-html="order.ticket.delivery_method"></span> #{{ order.ticket.fulfillment.tracking.number }} </div>
                    <a
                        class="order__action"
                        target="_blank"
                        :href="order.ticket.fulfillment.tracking.url">
                            Track My Order
                    </a>
                </div>
            </template> <!-- Hard local pickup ends-->
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.HARD_DELIVERED_TO_VENUE === deliveryDetailsType">
                <h4>Local Pickup</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-truck"></span>
                            <span>Tickets will be available on the venue premises on the day of the event.</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Location details and contact information will be sent to <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                </ul>
                <div v-if="hasTicketTrackingNumber" class="tracking-information">
                    <h3 class="tracking-information__header">Tracking Number</h3>
                    <div class="tracking-information__tracking_number"><span v-html="order.ticket.delivery_method"></span> #{{ order.ticket.fulfillment.tracking.number }} </div>
                    <a
                        class="order__action"
                        target="_blank"
                        :href="order.ticket.fulfillment.tracking.url">
                            Track My Order
                    </a>
                </div>
            </template> <!-- Hard venue delivery ends-->

            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.LAST_MINUTE === deliveryDetailsType">
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-location-marker"></span>
                            <span>Tickets will be available for pick-up at/near the venue</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Location details and contact information will be sent to <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                </ul>
            </template>
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.MOBILE_SCREENCAP_INSTANT === deliveryDetailsType">
                <h4>Instant Mobile Email Delivery</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Your tickets will be emailed to <strong>{{ order.customer.email_address }}</strong> in the next few minutes</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-mobile-qr"></span>
                            <span>Tickets must be displayed on your iOS or Android device to gain access to the event</span>
                        </div>
                    </li>
                </ul>
                <div v-if="order.current_status === ORDER_STATUS.SENT_TO_BUYER"
                    class="ticket-download"
                >
                    <template v-if="hasTicketEmailDownload">
                        <a class="ticket-download__action order__action"
                            target="_blank"
                            :href="order.ticket.fulfillment.links[0]"
                        >
                            Download
                        </a>
                    </template>
                    <template v-if="hasTicketPdfDownload">
                        <a class="ticket-download__action order__action"
                            target="_blank"
                            :href="order.ticket.fulfillment.pdf.url"
                        >
                            Download
                        </a>
                    </template>
                </div>
            </template>
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.MOBILE_SCREENCAP === deliveryDetailsType">
                <h4>Mobile Email Delivery</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Your tickets will be emailed to <strong>{{ order.customer.email_address }}</strong> when they are released</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Typically tickets are released quickly, but some venues withhold tickets until 48 hours prior to the event</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-mobile-qr"></span>
                            <span>Tickets must be displayed on your iOS or Android device to gain access to the event</span>
                        </div>
                    </li>
                </ul>
                <div v-if="order.current_status === ORDER_STATUS.SENT_TO_BUYER"
                    class="ticket-download"
                >
                    <template v-if="hasTicketEmailDownload">
                        <a class="ticket-download__action order__action"
                            target="_blank"
                            :href="order.ticket.fulfillment.links[0]"
                        >
                            Download
                        </a>
                    </template>
                    <template v-if="hasTicketPdfDownload">
                        <a class="ticket-download__action order__action"
                            target="_blank"
                            :href="order.ticket.fulfillment.pdf.url"
                        >
                            Download
                        </a>
                    </template>
                </div>
            </template>
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS_CARD_AT_VENUE === deliveryDetailsType ">
                <h4>Local Pickup</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-truck"></span>
                            <span>Tickets will be available on the venue premises on the day of the event</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Location details and contact information will be sent to <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                </ul>
            </template>
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS_CARD_COURIERED === deliveryDetailsType ">
                <h4>Shipped via UPS</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-truck"></span>
                            <span>Tickets will be shipped to <ShippingAddress :shipping-address="shippingAddress" /></span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>A tracking number will be sent to <strong>{{ order.customer.email_address }}</strong> when the tickets have been shipped</span>
                        </div>
                    </li>
                </ul>
            </template>
            <template v-else-if="VS_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS_CARD_NEAR_VENUE === deliveryDetailsType ">
                <h4>Local Pickup</h4>
                <ul class="delivery-details">
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-truck"></span>
                            <span>Pick up your tickets near the venue before your event</span>
                        </div>
                    </li>
                    <li class="stock-type__item">
                        <div class="display-flex">
                            <span class="stock-type__icon icon-email-2"></span>
                            <span>Location details and contact information will be sent to <strong>{{ order.customer.email_address }}</strong></span>
                        </div>
                    </li>
                </ul>
            </template>
            <!-- End Paperless-card section -->
        </section>

        <section
            class="detail"
            v-if="deliveryDate"
        >
            <h3 class="detail__heading">Expected Delivery</h3>
            <p class="detail__body">{{ deliveryDate | date }}</p>
        </section>
    </div>
</template>


<script>
import { ORDER_STATUS } from '../constants.js'
import { isDisplayInHandDate } from 'core/services/OrderService.js'
import { isInstantDelivery, isCourieredDelivery, INSTANT_DELIVERY_TYPES, TICKETMASTER_DELIVERY_TYPES } from 'core/utilities/DeliveryUtils'
import { VS_TICKET_STOCK_TYPES, HARD_TICKET_DELIVERY_TYPES} from '../enums'
import DateUtil from 'core/utilities/DateUtil'
import ShippingAddress from '../components/OrderCardShippingAddress'

const VS_STOCK_TYPE_DELIVERY_METHOD = {
    // This object enumerates the ways different stocktypes can be delivered.
    E_TICKETS: "e-tickets",
    E_TICKETS_INSTANT: "e-tickets-instant",
    HARD_COURIERED_TO_CUSTOMER: 'hard-couriered',
    HARD_DELIVERED_TO_VENUE: 'hard-venue-pickup',
    HARD_PICKUP_NEAR_VENUE: 'hard-near-venue',
    FLASH: 'flash',
    TICKETMASTER_TRANSFER: 'ticketmaster-transfer',
    TICKETMASTER_TEXT_TRANSFER: 'ticketmaster-text-transfer',
    TICKETMASTER_INSTANT_TRANSFER: 'ticketmaster-instant-transfer',
    MOBILE_SCREENCAP: 'mobile',
    MOBILE_SCREENCAP_INSTANT: "mobile screencap-instant",
    PAPERLESS_CARD_AT_VENUE: 'paperless-card',
    PAPERLESS_CARD_COURIERED: 'paperless-card-couriered',
    PAPERLESS_CARD_NEAR_VENUE: 'paperless-card-venue-pickup',
    PAPERLESS_WALK_IN: 'paperless walk-in',
    LAST_MINUTE: 'last-minute',
    UNKNOWN: '',
}

export default {
    beforeCreate () {
        this.VS_STOCK_TYPE_DELIVERY_METHOD = VS_STOCK_TYPE_DELIVERY_METHOD
        this.ORDER_STATUS = ORDER_STATUS
    },
    components: {
        ShippingAddress,
    },
    computed: {
        billingAddress () {
            return ((this.order || {}).customer || {}).billing_address || null
        },
        deliveryDate () {
            const deliveryDate = (((this.order || {}).ticket || {}).fulfillment || {}).estimated_delivery_date || null
            const isDisplayDeliveryDate = Boolean(deliveryDate) && isDisplayInHandDate(
                deliveryDate,
                this.order.date,
                this.order.event.local_date,
                this.order.ticket.stock_type.key,
                this.order.ticket.fulfillment.is_last_minute_local_delivery,
                this.order.event.is_lmlp
            )

            return isDisplayDeliveryDate ? deliveryDate : null
        },
        deliveryDetailsType () {
            if (!this.order) { return VS_STOCK_TYPE_DELIVERY_METHOD.UNKNOWN }

            if (!(this.order.ticket && this.order.ticket.stock_type)) {
                console.error('Order is missing ticket or ticket.stock_type')
                return VS_STOCK_TYPE_DELIVERY_METHOD.UNKNOWN
            }

            const ticketStockType = this.order.ticket.stock_type.key.toLowerCase()
            const isLastMinuteLocalDelivery = Boolean(this.order && this.order.ticket.fulfillment.is_last_minute_local_delivery)
            const isLastMinuteLocalPickup = Boolean(this.order && this.order.event.is_lmlp)
            let deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.UNKNOWN
            if (!this.$store.state.selectedDeliveryOption) {
                return deliveryDetailsType
            }
            const delivery = this.$store.state.selectedDeliveryOption.id

            if (isLastMinuteLocalDelivery || isLastMinuteLocalPickup) {
                deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.LAST_MINUTE
            } else {
                switch (ticketStockType) {
                case VS_TICKET_STOCK_TYPES.E_TICKETS:
                    deliveryDetailsType = isInstantDelivery(delivery) ? VS_STOCK_TYPE_DELIVERY_METHOD.E_TICKETS_INSTANT : VS_STOCK_TYPE_DELIVERY_METHOD.E_TICKETS
                    break
                case VS_TICKET_STOCK_TYPES.HARD:
                    if (isCourieredDelivery(delivery)) {
                        deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.HARD_COURIERED_TO_CUSTOMER
                    } else if (delivery === HARD_TICKET_DELIVERY_TYPES.SPECIAL_DELIVERY) {
                        deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.HARD_DELIVERED_TO_VENUE
                    } else {
                        deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.HARD_PICKUP_NEAR_VENUE
                    }
                    break
                case VS_TICKET_STOCK_TYPES.FLASH:
                    deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.FLASH
                    break
                case VS_TICKET_STOCK_TYPES.TICKETMASTER_TRANSFER:
                    switch (delivery) {
                        case TICKETMASTER_DELIVERY_TYPES.ELECTRONIC_TRANSFER:
                            deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.TICKETMASTER_TRANSFER
                            break
                        case TICKETMASTER_DELIVERY_TYPES.TEXT_MOBILE_TRANSFER:
                            deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.TICKETMASTER_TEXT_TRANSFER
                            break
                        case TICKETMASTER_DELIVERY_TYPES.INSTANT_TRANSFER:
                            deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.TICKETMASTER_INSTANT_TRANSFER
                            break
                    }
                    break
                case VS_TICKET_STOCK_TYPES.MOBILE_SCREENCAP:
                    deliveryDetailsType = isInstantDelivery(delivery) ? VS_STOCK_TYPE_DELIVERY_METHOD.MOBILE_SCREENCAP_INSTANT : deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.MOBILE_SCREENCAP
                    break
                case VS_TICKET_STOCK_TYPES.PAPERLESS_CARD:
                    if (isCourieredDelivery(delivery)) {
                        deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS_CARD_COURIERED
                    } else if (delivery === INSTANT_DELIVERY_TYPES.SPECIAL_DELIVERY) {
                        deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS_CARD_AT_VENUE
                    } else {
                        deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS_CARD_NEAR_VENUE
                    }
                    break
                case VS_TICKET_STOCK_TYPES.PAPERLESS_WALK_IN:
                    deliveryDetailsType = VS_STOCK_TYPE_DELIVERY_METHOD.PAPERLESS_WALK_IN
                    break
                default:
                    console.error(`Unkown Ticket Stock Type: ${ticketStockType}`)
                }
            }
            return deliveryDetailsType
        },
        shippingAddress () {
            if (!(this.order && this.order.customer && this.order.customer.shipping_address)) { return null }
            return this.order.customer.shipping_address
        },
        hasTicketEmailDownload () {
            return this.order.ticket.fulfillment.type === 'EMAIL' && this.order.ticket.fulfillment.links.length
        },
        hasTicketPdfDownload () {
            return (this.order.ticket.fulfillment.type === 'PDF' || this.order.ticket.fulfillment.type === 'QR') && (this.order.ticket.fulfillment.pdf || {}).url
        },
        hasTicketTrackingNumber () {
            return (this.order.ticket.fulfillment.tracking || {}).number &&
                (this.order.ticket.fulfillment.tracking || {}).url &&
                this.order.ticket.fulfillment.type === 'SHIP'
        }
    },
    filters: {
        date (value, format = 'MMM D, YYYY') {
            return DateUtil.format(value, format)
        }
    },
    props: {
        order: {
            required: true,
            type: Object
        }
    }
}
</script>

<style lang="postcss" scoped>
.display-flex {
    display: flex
}
div.display-flex span {
    display: block
}
div.display-flex span.stock-type__icon {
    margin-right: 8px;
}
ul.delivery-details:first-child {
    margin-top: 4px;
}
</style>
